export enum ProjectProcessKind {
  VORGANG = 'VORGANG',
  MEILENSTEIN = 'MEILENSTEIN',
  GLIEDERUNGSPUNKT = 'GLIEDERUNGSPUNKT',
}
